import { useTranslations } from 'next-intl';

import type { OtpDeliveryStatus, OtpVerificationModalTranslations } from '@ui/components/features/otp';

const DELIVERY_STATUSES: OtpDeliveryStatus[] = ['sending', 'pending', 'accepted', 'delivered', 'unknown', 'failed'];

/**
 * Strings for the shared `OtpVerificationModal`. Placeholders the modal fills itself
 * ({phoneNumber}, {seconds}, {carrier}, {time}, {reason}) are passed through as literal tokens.
 */
export function useOtpModalTranslations(): OtpVerificationModalTranslations {
  const t = useTranslations('Otp');
  const tCommon = useTranslations('Common');
  const placeholders = { carrier: '{carrier}', time: '{time}', reason: '{reason}' };
  const deliveryTexts = (channel: 'sms' | 'call') =>
    Object.fromEntries(
      DELIVERY_STATUSES.map((status) => [status, t(`delivery.${channel}.${status}`, placeholders)])
    ) as Record<OtpDeliveryStatus, string>;

  return {
    title: t('title'),
    subtitle: t('subtitle', { phoneNumber: '{phoneNumber}' }),
    subtitleCall: t('subtitleCall', { phoneNumber: '{phoneNumber}' }),
    subtitleSendFailed: t('subtitleSendFailed', { phoneNumber: '{phoneNumber}' }),
    verify: t('verify'),
    resendCode: t('resendCode'),
    resendIn: t('resendIn', { seconds: '{seconds}' }),
    invalidCode: t('invalidCode'),
    cancel: tCommon('cancel'),
    changeNumber: t('changeNumber'),
    callMe: t('callMe'),
    delivery: { sms: deliveryTexts('sms'), call: deliveryTexts('call') },
    failureReasons: {
      invalid_number: t('failureReasons.invalid_number'),
      unreachable: t('failureReasons.unreachable'),
      blocked: t('failureReasons.blocked'),
      opted_out: t('failureReasons.opted_out'),
      carrier_error: t('failureReasons.carrier_error'),
      no_answer: t('failureReasons.no_answer')
    },
    enterCode: t('enterCode')
  };
}
